import React from "react";
import { Subtitle } from "./shared/Subtitle";
import { Title } from "./shared/Title";
import { styled } from "styled-components";
import SimpleSlider from "./shared/Slider";

const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 1000px;
  padding: 70px 5%;

  & .description {
    max-width: 750px;
    margin: 50px auto;
  }

  & .centeredText {
    max-width: 600px;
    margin: auto;
    text-align: center;
  }

  & .footerText {
    max-width: 700px;
    margin: auto;
    text-align: center;
  }
`;

const ContentVideo = styled.div`
  display: flex;
  justify-content: center;
`;

export const Testimonials = () => {
  return (
    <Wrapper>
      <Subtitle>Ellos ya lo han conseguido. Ahora es tu turno.</Subtitle>
      <Title>
        Historias de éxito: nuestros alumnos hablan de cómo el bootcamp cambió
        sus vidas
      </Title>
      <ContentVideo>
        <iframe
          width="500"
          height="300"
          src="https://youtube.com/embed/N057goTIoSE"
        ></iframe>
      </ContentVideo>
      <p className="description">
        Nuestros antiguos alumnos son la mejor prueba de que Beyond funciona.
        Desde conseguir su primer empleo como desarrolladores hasta dar un giro
        radical a sus carreras, sus historias inspiran y demuestran el impacto
        real del programa.
      </p>
      <div>
        <SimpleSlider />
      </div>
      <span id="price"></span>
    </Wrapper>
  );
};
